export default "__VITE_ASSET__DgNgdDGX__"